import type { Installment, InstallmentStatus } from "@/types/installment";
import { aggregateFailures, inDueRange } from "@/pages/retailer/installments/data";

const COLLECTED: InstallmentStatus[] = ["COLLECTED", "SETTLEMENT_PENDING", "SETTLED", "SETTLEMENT_FAILED", "COLLECTED_OFFLINE"];

export function retailerById(_id: string): { id: string; shopName: string } | null {
  return null;
}

export function initials(name: string): string {
  return (name || "")
    .split(" ")
    .map((p) => p[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

export function filterByDueRange(items: Installment[], range: string, from: string, to: string): Installment[] {
  return items.filter((t) => inDueRange(t.dueDate, range, from, to));
}

export function failureStats(items: Installment[]) {
  return aggregateFailures(items);
}

export function collectionRate(items: Installment[]): number {
  const collected = items.filter((t) => COLLECTED.includes(t.status)).length;
  const presented = items.filter((t) => COLLECTED.includes(t.status) || t.status === "FAILED").length;
  return presented ? (collected / presented) * 100 : 0;
}

export function collectionRateColor(rate: number): string {
  if (rate > 90) return "#059669";
  if (rate >= 75) return "#D97706";
  return "#DC2626";
}